// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/glaromat-user-schema',
  type: 'object',
  required: ['id', 'creatorId'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    siHaAgbAccepted: {
      type: 'boolean',
    },
    companyLogoDocumentExternalId: {
      type: 'string',
      nullable: true,
    },
    companyName: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    companyAddress: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    firstName: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    lastName: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
  },
} as IJSONSchema;

export default schema;
